// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  ICertificationWebpagePersonalDataGetDetailAttrs,
  ICertificationWebpagePersonalDataUpdateAttrs,
} from 'interfaces/webpage/certification/registration/personal-data/personal-data-view.interface'

const useCertificationPersonalData = () => {
  // Hook
  const {
    certificationWebpagePersonalData: {
      certificationWebpagePersonalData_loading,
      certificationWebpagePersonalData_detail,
      certificationWebpagePersonalData_CLEAR_DETAIL,
      certificationWebpagePersonalData_fetchDetail: fetchDetail,
      certificationWebpagePersonalData_update: update,
    },
  } = useStores()

  /**
   * @description Get personal data detail
   *
   * @param {ICertificationWebpagePersonalDataGetDetailAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const certificationWebpagePersonalData_fetchDetail = useCallback(
    (payload: ICertificationWebpagePersonalDataGetDetailAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDetail],
  )

  /**
   * @description Update personal data
   *
   * @param {ICertificationWebpagePersonalDataUpdateAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const certificationWebpagePersonalData_update = useCallback(
    (payload: ICertificationWebpagePersonalDataUpdateAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        update({
          params: { ...payload.params },
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [update],
  )

  return {
    certificationWebpagePersonalData_loading,
    certificationWebpagePersonalData_detail,
    certificationWebpagePersonalData_CLEAR_DETAIL,
    certificationWebpagePersonalData_fetchDetail,
    certificationWebpagePersonalData_update,
  }
}

export { useCertificationPersonalData }
